import CyberSecurity from '../../../apis/cyberSecurityData';

export const setActiveChannel = (channel) => {
  return {
    type: 'SET_PERSONAL_ACTIVE_CHANNEL',
    payload: channel
  }
}

export const loadPersonalChannels = () => async (dispatch, getState) => {
  const user = getState().currentUser;
  if (user._id) {
    const channelsResponse = await CyberSecurity.get('/pboards/channels', {
      headers: {
        Authorization: 'Bearer ' + getState().accessToken
      }
    })
    dispatch({
      type: 'LOAD_PERSONAL_CHANNELS',
      payload: channelsResponse.data
    })

    const activeChannel = getState().personalBoard.activeChannel;

    if (channelsResponse.data && channelsResponse.data.length > 0 && activeChannel === '') {
      dispatch({
        type: 'SET_PERSONAL_ACTIVE_CHANNEL',
        payload: channelsResponse.data[0]
      })
    }
  }

}

export const createPersonalChannel = (name) => async (dispatch, getState) => {
  try {
    const response = await CyberSecurity.post('/pboards/channels', { name }, {
      headers: {
        Authorization: 'Bearer ' + getState().accessToken
      }
    })

    dispatch({
      type: 'LOAD_PERSONAL_CHANNELS',
      payload: response.data
    })

  } catch (error) {
    console.log(error.message)
  }
}

export const renamePersonalChannel = (channelId, name) => async (dispatch, getState) => {

  //rename channel
  try {
    const response = await CyberSecurity.patch('/pboards/channels', { channelId, name }, {
      headers: {
        Authorization: 'Bearer ' + getState().accessToken
      }
    })
    console.log(response.data)
    dispatch({
      type: 'LOAD_PERSONAL_CHANNELS',
      payload: response.data
    })

    //update active channel if the active is the renamed one
    const activeChannel = getState().personalBoard.activeChannel;
    console.log(activeChannel)
    console.log(activeChannel._id === channelId)
    if (activeChannel && activeChannel._id === channelId) {
      dispatch({
        type: 'SET_PERSONAL_ACTIVE_CHANNEL',
        payload: { ...activeChannel, name }
      })
    }

  } catch (error) {
    console.log(error.message)
  }
}

export const deletePersonalChannel = (channelId) => async (dispatch, getState) => {

  //delete channel
  try {
    const response = await CyberSecurity.delete('/pboards/channels', {
      data: { channelId },
      headers: {
        Authorization: 'Bearer ' + getState().accessToken
      }
    })

    dispatch({
      type: 'DELETE_PERSONAL_CHANNEL',
      payload: channelId
    })

    //checking if the deleted channel is the active channel
    const activeChannel = getState().personalBoard.activeChannel;

    if (activeChannel._id === channelId) {
      const channels = getState().personalBoard.channels;
      if (channels && channels.length > 0) {
        dispatch({
          type: 'SET_PERSONAL_ACTIVE_CHANNEL',
          payload: channels[0]
        })
      }
    }

  } catch (error) {
    console.log(error.message)
  }

  //update active channel if the active is the deleted one
}